import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const DOWNLOAD_API = `${API_HOST}/api/exportTask`;
const UPDATE_EXPORT_TASKS_URL = `${DOWNLOAD_API}`;
const SEARCH_EXPORT_TASKS_URL = `${DOWNLOAD_API}`;
const SEARCH_POINT_EXPORT_TASKS_URL = `${DOWNLOAD_API}/point`;
const CREATE_POINT_EXPORT_TASK_URL = `${DOWNLOAD_API}/point`;
const DOWNLOAD_EXPORTED_FILES_URL = `${DOWNLOAD_API}`;
const UPDATE_EXPORT_EXCEL_TASKS_URL = `${DOWNLOAD_API}/excel`;

function* updateExportTasks() {
  yield takeEvery(actions.UPDATE_EXPORT_TASKS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], UPDATE_EXPORT_TASKS_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_EXPORT_TASKS_ENDED });
    }
  });
}

function* updateExportExcelTasks() {
  yield takeEvery(actions.UPDATE_EXPORT_EXCEL_TASKS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], UPDATE_EXPORT_EXCEL_TASKS_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_EXPORT_EXCEL_TASKS_ENDED });
    }
  });
}

function* downloadExportedFiles() {
  yield takeEvery(actions.DOWNLOAD_EXPORTED_FILES, function* (action) {
    const { parameters, onSuccess } = action;

    try {
      const res = yield call(
        [axios, 'get'],
        `${DOWNLOAD_EXPORTED_FILES_URL}/${parameters.id}/file`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DOWNLOAD_EXPORTED_FILES_ENDED });
    }
  });
}

function* fetchExportFilesInformation() {
  yield takeEvery(actions.SEARCH_EXPORT_TASKS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SEARCH_EXPORT_TASKS_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EXPORT_TASKS_ENDED });
    }
  });
}

function* fetchExportPointFilesInformation() {
  yield takeEvery(actions.SEARCH_POINT_EXPORT_TASKS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SEARCH_POINT_EXPORT_TASKS_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_POINT_EXPORT_TASKS_ENDED });
    }
  });
}

function* searchExpiringSoonMemberPointReports() {
  yield takeEvery(actions.SEARCH_EXPIRING_SOON_MEMBER_POINT_REPORTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${DOWNLOAD_API}/expiringSoonMemberPointReport?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EXPIRING_SOON_MEMBER_POINT_REPORTS_ENDED });
    }
  });
}

function* createPointExportTask() {
  yield takeEvery(actions.CREATE_POINT_EXPORT_TASK, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], CREATE_POINT_EXPORT_TASK_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_POINT_EXPORT_TASK_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(updateExportTasks),
    fork(updateExportExcelTasks),
    fork(downloadExportedFiles),
    fork(fetchExportFilesInformation),
    fork(fetchExportPointFilesInformation),
    fork(searchExpiringSoonMemberPointReports),
    fork(createPointExportTask),
  ]);
}
